import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLFlowManifest } from '../interfaces';
import { TpETLPipeline } from '../../interfaces';
import { importPipelineFromYaml } from '../../utils';
import { generateDashboardYaml, generateEntityYaml, generatePipelineYaml } from './pipeline-templates';
import { FORM_DATATYPES, promptAutoForm, TpAutoFormDef } from '../../../../components/auto-form-modal/AutoForm';

function promptPubmedInput(): Promise<string> {
  const form: TpAutoFormDef = {
    title: `Define the disease or gene you want to run the case study on:`,
    fields: [
      {
        id: 'pubmedInput',
        name: 'Disease / Gene',
        dataType: FORM_DATATYPES.STRING,
        startContent: '',
        required: true,
      },
    ],
  };

  return promptAutoForm(form).then((dataForm: any) => {
    return dataForm.pubmedInput;
  });
}

function getPipeline(): Promise<TpETLPipeline> {
  return promptPubmedInput().then((inputText: string) => {
    return importPipelineFromYaml(generatePipelineYaml(inputText));
  });
}

export const manifestETLPubmedCaseStudy: TpETLFlowManifest = {
  id: 'PubmedCaseStudy',
  name: 'Pubmed Case Study',
  description:
    'Based on an input disease or gene, this flow will search for relevant publications on Pubmed and create a dashboard overview with all relevant Publications.',
  icon: <FontAwesomeIcon icon={['fas', 'diagram-project']} />,
  getPipeline: getPipeline,
  dashboardTemplate: generateDashboardYaml(),
  entityTemplate: generateEntityYaml(),
};
